import { Component, Input, Injector, inject } from "@angular/core";
import { OrgIndividualTeamsComponent } from "../org-individual-teams.component";
import { environment } from "../../../../environments/environment";
import { HttpService } from "./../../../http.service";
import { CommonDataService } from "../../common-data.service";

@Component({
  selector: "app-directory-view",
  templateUrl: "./directory-view.component.html",
  styleUrls: ["./directory-view.component.scss"],
})
export class DirectoryViewComponent {
  injectedCompo;
  loader: boolean = false;
  view: string = "dirView"; // dirView or memView
  currentPg = 1;
  totalMemberView: number = 20;
  sortType: string = "asc";

  constructor(
    public injector: Injector,
    private httpService: HttpService,
    private commonService: CommonDataService
  ) {
    this.injectedCompo = this.injector.get(OrgIndividualTeamsComponent);
  }

  openSideBar(team) {
    this.injectedCompo.teamID=team?.id
    console.log(team);
    this.view = "memView";
    this.injectedCompo.gridHirView = "memView";
    this.injectedCompo.memViewTeam = team;
    this.currentPg = 1;
    this.loader = true;
    this.injectedCompo.teamSrchName = ''
    if (
      this.injectedCompo.memViewTeam?.memberships_count > 20 &&
      this.injectedCompo.memViewTeam?.memberships?.length <= 20
    ) {
      // this.injectedCompo.loadMore(team.id);
      // let allTeamMem:any = this.httpService.getRequest(`${environment.profileURL}/api/v1/teams/`+team.id+`/memberships.json?name_order=asc&per_page=${team?.memberships_count}`)
      // allTeamMem.subscribe((res)=> {
      //   this.team.memberships = res.memberships;
      setTimeout(() => {
        this.loader = false;
      }, 1000);
      // })
    } else {
      this.loader = false;
    }
  }

  getSortedData(sortBy: string, sortType: string) {
    this.sortType = sortType;
    if (this.view == "dirView") {
      let sortData: any = this.commonService.sortData(
        `${environment.profileURL}/api/v1/organizations/` +
          this?.injectedCompo?.id +
          `/teams.json?page=${this.currentPg}&per_page=${this.injectedCompo.teamsPerPage}&`,
        sortBy,
        sortType
      );
      sortData.subscribe((res: any) => {
        console.log("result", res);
        this.injectedCompo.teams = res?.teams;
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      });
    }
  }

  updateCurrentPg(pg) {
    console.log(pg);
    this.currentPg = pg;
    if (this.view == "memView") {
      let memberResult = this.commonService.getPageData(
        `${environment.profileURL}/api/v1/teams/` +
          this.injectedCompo.memViewTeam.id +
          `/memberships.json`,
        pg,
        this.totalMemberView
      );
      memberResult.subscribe((res: any) => {
        console.log("result", res);
        this.injectedCompo.memViewTeam.memberships = res?.memberships;
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      });
    } else if (this.view == "dirView") {
      let memberResult = this.commonService.getPageData(
        `${environment.profileURL}/api/v1/organizations/` +
          this?.injectedCompo?.id +
          `/teams.json`,
        pg,
        this.totalMemberView
      );
      memberResult.subscribe((res: any) => {
        console.log("result", res);
        this.injectedCompo.teams = res?.teams;
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      });
    }
  }
}
